import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {connect} from 'react-redux';
import SupportedTV from '../SupportedTV/SupportedTV';
import {displaySupportedTV} from '../SupportedTV/SupportedTVSlice';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';

const appSaleWelcome = (props) => {

  const appDisplaySupportedTVHandler = () => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    gaEvent(gaParams.APP_NEW_SALE_SUPPORTED_TV_OPEN.category, gaParams.APP_NEW_SALE_SUPPORTED_TV_OPEN.eventType, eventLabel);
    props.displaySupportedTV(true);
  };

  return (
    <Container className='app-Sale-Welcome'>
      <Row>
        <Col>
          <Row>
            <Col sm='12' className='check-tv-link' onClick={() => appDisplaySupportedTVHandler()}>
              <span>האם הטלוויזיה שלי נתמכת? לחצו כאן לבדיקה</span>
              <Image src={require('./images/arrow.svg')} alt='חץ' />
            </Col>
          </Row>
          <Row>
            <Col className='appSale-image'>
              <Image src={require('./images/appSale.svg')} className='appSale-img' alt='טלויזיה חכמה' />
            </Col>
          </Row>
          <SupportedTV supportedTVText={props.saleBlock.supportedTVText} />
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    productsInfo: state.saleBlock.productsInfo,
    saleBlock: state.saleBlock.epiServer.saleBlock
  };
};

const mapDispatchToProps = {
  displaySupportedTV,
};

export default connect(mapStateToProps, mapDispatchToProps)(appSaleWelcome);
